import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { compose, branch, renderNothing, lifecycle } from 'recompose'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import ACCESS from 'utils/Access'

import { makeHasGate } from 'app/modules/gates/selectors'
import * as EndUserSelectors from 'app/modules/endUser/selectors'
import * as EndUserActions from 'app/modules/endUser/actions'
import { track } from 'app/modules/tracking/actions'

import * as style from './style.styl'

import FOLLOW_ICON_SRC from '!svg-inline?removeTags=true!images/live/enduser-follow-live.svg'
import FOLLOWING_ICON_SRC from '!svg-inline?removeTags=true!images/live/enduser-following-live.svg'

class FollowButton extends Component {
  updateFollowingStatus = () => {
    const { endUser, isFollowing } = this.props

    track('Conversation Sidebar - Clicked Contact Follow')

    this.props.actions.updateFollowing({
      following: !isFollowing,
      id: endUser.id
    })
  }

  render() {
    const {
      className,
      isFollowing,
      hasPremiumTeam,
    } = this.props

    return hasPremiumTeam ? (
      <div className={cx(style.followButton, className, 'link')} onClick={this.updateFollowingStatus}>
        <IconSVG className="follow-icon" src={isFollowing ? FOLLOWING_ICON_SRC : FOLLOW_ICON_SRC} />
        { isFollowing ? 'Following' : 'Follow' }
      </div>
    ) : (
      <Link className={cx(style.followButton, className)} to="/live">
        <IconSVG className="follow-icon" src={isFollowing ? FOLLOWING_ICON_SRC : FOLLOW_ICON_SRC} />
        {isFollowing ? 'Following' : 'Follow'}
      </Link>
    )
  }
}

const makeMapStateToProps = function() {
  return function(state, props) {
    const { endUser } = props

    return {
      hasFollowing: ACCESS.hasGates('has_following'),
      isFollowing: endUser && EndUserSelectors.followingId(endUser.id)(state),
      hasPremiumTeam: makeHasGate('premium_team')(state),
    }
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchFollowing: EndUserActions.fetchFollowing,
      updateFollowing: EndUserActions.updateFollowing,
    },
    dispatch
  )
})

export default compose(
  branch(props => !props.endUser, renderNothing),
  connect(makeMapStateToProps, mapDispatchToProps),
  branch(props => !props.hasFollowing, renderNothing),
  lifecycle({
    componentDidMount() {
      const { endUser, actions } = this.props
      actions.fetchFollowing({ id: endUser.id })
    }
  }),
)(FollowButton)



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/FollowButton/index.js